import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, orderBy, last } from "keautils";
import { validation, formfields, Tab } from "kea-react"

import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { SegmentosList } from "./puntos/listSegmentos";
import { TrasbordoList } from "./trasbordos";

type Entity = models.RutaDTO;
export interface Props {
    value: Entity;
    onChange: (value: Entity) => Promise<void> | void;
    onGuardar: () => Promise<void>;
    nuevo: boolean;
}

function validarRuta(ruta: models.RutaSucursalDTO[]) {
    const puntos = orderBy(ruta, x => x.Orden);
    if (puntos.length < 2) {
        return "La ruta debe de tener por lo menos 2 segmentos";
    }


    if (puntos[0].IdSucursalOrigen != last(puntos)!.IdSucursalDestino) {
        return "El final de la ruta debe de ser el principio de la ruta";
    }

    for (let i = 1; i < puntos.length; i++) {
        let last = i - 1;
        if (puntos[last].IdSucursalDestino != puntos[i].IdSucursalOrigen) {
            return `El punto no. ${i + 1} tiene un origen diferente al destino del punto anterior ${last + 1}`;
        }
    }

    return true;
}

/**
* Valida un Ruta
*/
export function validar(x: Entity) {
    const rules: validation.Rules<Entity> = {
        RutaSucursales: x => validarRuta(x.RutaSucursales)
    };
    return validation.getErrors(rules, x);
}

/**
* Componente para editar un Entity
*/
export class RutaFormNoRx extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    errors = createSelectorRx(this.value, x => validar(x));
    hasError = createSelectorRx(this.errors, x => validation.hasError(x));
    getField = formfields(() => this.props, () => this.errors(this.props));


    render() {
        const { value, onGuardar, nuevo } = this.props;
        const getField = this.getField;

        const hasError = this.hasError(this.props);
        const Text = getField(kea.Text);
        const Checkbox = getField(kea.Checkbox);
        const Segmentos = getField(SegmentosList);
        const Trasbordos = getField(TrasbordoList);
        const Number = getField(kea.Number);
        return (
            <div>
                <kea.Title titulo="Ruta" onRegresar={() => history.go("/catalogos/Ruta")} />
                {kea.autogrid(6, [
                    <Text field="Nombre" />,
                    <Number field="PorcentajeUtilidadFleteLogistica" label="Porcentaje Utilidad Flete Logistica"  format={"percentage"}/>,
                    <Checkbox field="Deshabilitar" label="Deshabilitar" />,
                    <Checkbox field="TrasbordoDefinido" label="Sólo permitir trasbordos en las sucursales especificadas" />,
                ])}

                    <kea.Tab items={[
                        {
                            title: "Segmentos",
                            body: <Segmentos field="RutaSucursales" />
                        }, {
                            title: "Sucursales de trasbordo",
                            body: <Trasbordos field="SucursalesTrasbodo" />
                        }
                    ]}>
                    </kea.Tab>
                <div className="row">
                    <div className="col-md-12">
                        <kea.GuardarButton onClick={onGuardar} disabled={hasError} />
                    </div>
                </div>
            </div>);
    }
}

export const RutaForm = componentToRx(RutaFormNoRx);


// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/rutas/edit/form.tsx